var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.80789 0.0185547H0.191895V1.53166H2.87767C3.86399 1.53166 4.70523 2.16414 5.01751 3.04476H0.191895V4.55786H5.01751C4.70523 5.43848 3.86399 6.07096 2.87767 6.07096H0.191895V7.58406L4.62634 12.0186L5.69626 10.9486L2.33176 7.58411H2.87767C4.70446 7.58411 6.23293 6.28244 6.58438 4.55788H7.80789V3.04478H6.58438C6.47052 2.48603 6.23305 1.97174 5.90197 1.53168H7.80789V0.0185547Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInr);
export default __webpack_public_path__ + "static/media/inr.2ed5b7ec.svg";
export { ForwardRef as ReactComponent };